export default {
	dependencies: {
		title: "Dependencies",
		hint: "Another project's types, dataobjects and activities, pinned at a version. Its entities become part of this project's vocabulary — read-only, since they live in the other project.",
		add: "Add dependency",
		sync: "Re-resolve",
		synced: "Dependencies re-resolved.",
		syncedWithImpact: "Re-resolved. Some entities no longer exist: {aliases}.",
		empty: "No dependencies yet.",
		sourceProject: "Source project",
		version: "Version",
		nothingBuilt: "The selected project has no built versions yet. Build or release it first.",
		alias: "Alias",
		aliasHelp:
			"The local name for this dependency. Lowercase letters, digits, hyphens and underscores.",
		aliasInvalid:
			"Use lowercase letters, digits, hyphens and underscores only, up to 64 characters.",
		aliasTaken: "That alias is already in use.",
		added: "Added dependency “{alias}”.",
		updated: "Updated dependency “{alias}”.",
		removed: "Removed dependency “{alias}”.",
		remove: "Remove",
		definedIn: "defined in {alias}",
		readOnly: "Defined in {alias}, so it is read-only here. Change it in that project.",
		predefined: "predefined by Notitia",
		predefinedReadOnly: "Predefined by Notitia, so it is read-only here.",
		changeVersion: "Change to {version}",
		wipOption: "wip (not reproducible)",
		wipWarning:
			"A wip pin follows the source project's current state. Two builds at different times can consume different content — release a version when reproducibility matters.",
		stale: "The source of “{alias}” has changed since this pin was resolved. Nothing this project uses is affected, so the new version is already in use — re-resolve to record it.",
		sourceNotReadable:
			"You need permission to read builds of the source project to depend on it.",
		pending: {
			title: "Changes in “{alias}” are waiting for your review",
			body: "The source of “{alias}” moved. Adopting it would break {count} reference in this project. Writes that regenerate code are blocked until you re-resolve. | The source of “{alias}” moved. Adopting it would break {count} references in this project. Writes that regenerate code are blocked until you re-resolve.",
			adopt: "Adopt and re-resolve",
			collisions: "Name collisions",
			collisionsHeld:
				"Re-resolving is refused until a source project renames one of the two.",
		},
		surfaceUnavailable:
			"This package could not be read, so the dependency contributes nothing. The pin is still recorded.",
		collision:
			"A name in this dependency collides with one already in scope. It cannot be fixed from here: a class name is its runtime identity, so renaming it at build time would break relation creation. Rename it in one of the two source projects and release.",
		diagnostics: {
			wipMoved:
				"A dependency changed since it was last re-resolved. Nothing this project uses is affected, so the new version is in use.",
			wipBlocked:
				"A dependency changed in a way that affects this project. Review the impact in the dependency settings and re-resolve to continue.",
			selectPresentationPruned:
				"A dependency's type no longer has some values that questions here ordered or gave their own colour or image. Those settings were removed. Everything else is unchanged.",
		},
		notice: {
			blocked: "Dependency changes to review",
			blockedTooltip:
				"“{aliases}” changed in a way that affects this project. Review the impact and re-resolve to continue — writes that regenerate code are blocked until then.",
			moved: "Dependency changed",
			movedTooltip:
				"“{aliases}” changed. Nothing this project uses is affected, so the new version is already in use. Re-resolve to record it.",
		},
		impact: {
			title: "What this changes for “{alias}”",
			none: "Nothing in this project references entities this change would remove.",
			warning:
				"This change would leave the references below pointing at entities that no longer exist.",
			bestEffort:
				"Found by scanning code text, so this list is worth a look rather than exhaustive.",
			refused:
				"The change was refused: it would break the references below. Review them, then apply anyway or cancel.",
			groups: {
				attributes: "Attributes",
				relations: "Relations",
				process_entries: "Process entries",
				activity_bindings: "Activity bindings",
				axioms: "Axioms",
				custom_action_bodies: "Custom Action code",
				activities: "Activities",
				action_types: "Action types",
				union_members: "Union types",
				views: "Views",
				attribute_paths: "Attribute paths",
				type_values: "Type values",
				terminology_overrides: "Your relabelled terms",
			},
			notes: {
				views: "Applying the change removes these from the views that list them.",
				terminology_overrides:
					"Applying the change drops these relabellings: no remaining entity uses the term.",
			},
		},
		npm: {
			title: "npm packages",
			hint: "Ordinary npm packages for Custom Action code. Checked for name and range syntax only — a package that does not exist shows up when the project builds.",
			add: "Add package",
			added: "Package added.",
			removed: "Removed “{name}”.",
			empty: "No npm packages.",
			name: "Package name",
			range: "Version range",
			rangeHelp: "A semver range, for example ^4.1.0.",
			dev: "Dev dependency",
		},
	},
};
